import { render, staticRenderFns } from "./SaveCancel.vue?vue&type=template&id=2c4646a4&scoped=true&"
import script from "./SaveCancel.vue?vue&type=script&lang=js&"
export * from "./SaveCancel.vue?vue&type=script&lang=js&"
import style0 from "./SaveCancel.vue?vue&type=style&index=0&id=2c4646a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4646a4",
  null
  
)

export default component.exports